// Detecta se a string ISO traz fuso explícito (Z ou ±HH:MM / ±HHMM no fim).
const TIMEZONE_RE = /(?:Z|[+-]\d{2}:?\d{2})$/;
// Extrai os componentes crus (ano, mês, dia, hora, minuto) de uma data ISO,
// sem conversão de fuso — usado para preservar o padrão quando não há GMT.
const NAIVE_RE = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/;

const pad = (n: number): string => String(n).padStart(2, '0');

/**
 * Formata data/hora de editais na máscara `dd/mm/aaaa, hh:mm`.
 *
 * Regra de fuso:
 * - quando a string traz GMT (`Z` ou `±HH:MM`), o valor é um instante absoluto:
 *   aplica-se o fuso convertendo para o horário local do usuário;
 * - quando NÃO há GMT (data "ingênua", ex.: `2026-09-17T14:45:12.792`), mantém-se
 *   o padrão recebido — os componentes são remontados sem qualquer conversão.
 *
 * Valor ausente/vazio devolve `'-'` (placeholder de UI do projeto). Formato
 * inesperado é devolvido como veio, sem lançar.
 */
export const formatDateTimeBR = (value?: string | null): string => {
  if (!value) return '-';
  const raw = String(value).trim();
  if (!raw) return '-';

  // Sem GMT: mantém o padrão recebido, só aplica a máscara aos componentes crus.
  if (!TIMEZONE_RE.test(raw)) {
    const m = NAIVE_RE.exec(raw);
    if (!m) return raw;
    const [, yyyy, mm, dd, hh, min] = m;
    return `${dd}/${mm}/${yyyy}, ${hh}:${min}`;
  }

  // Com GMT: instante absoluto — aplica o fuso (converte para o horário local).
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return raw;
  return (
    `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}, ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}`
  );
};
